import React from 'react';
import { Wrapper } from './SmallCompressorsStyle';

const SmallCompressorsWrapper = ({ children }) => <Wrapper>{children}</Wrapper>;

export default SmallCompressorsWrapper;
